import type { TourStep } from '../types';

export const designEditSteps: TourStep[] = [
  {
    target: '[data-tour="design-edit-modal"]',
    title: 'Редактирование дизайна',
    content: 'Здесь вы можете изменить метаданные существующего дизайна. Файл макета можно заменить в отдельном интерфейсе.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-code"]',
    title: 'Код дизайна',
    content: 'Уникальный код дизайна (design_code). Формируется автоматически и используется для связи с товарами.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-theme-number"]',
    title: 'Номер темы',
    content: 'Номер темы для группировки связанных дизайнов. Можно изменить при реорганизации каталога.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-type"]',
    title: 'Тип',
    content: 'Тип дизайна определяет способ его использования и отображения в каталоге.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-brand"]',
    title: 'Бренд',
    content: 'Название бренда на русском и английском языках. Отображается в карточках товаров.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-targeting"]',
    title: 'Таргетинг',
    content: 'Настройки целевой аудитории: пол, возраст. Влияет на размещение в категориях маркетплейсов.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-metadata"]',
    title: 'Метаданные',
    content: 'Дополнительная информация: сезонность, язык, тема, эмоция. Помогает в поиске и фильтрации.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-edit-save"]',
    title: 'Сохранение',
    content: 'Нажмите "Сохранить" для применения изменений. Обновлённые данные отобразятся во всех связанных товарах.',
    placement: 'top',
    disableBeacon: true,
  },
];
